module.exports = __webpack_public_path__ + "static/img/banner-one.5663bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-one.png
// module id = 95mk
// module chunks = 34